import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M7.676 1.997a.27.27 0 0 0-.176.253c0 .112.07.213.176.253L9 3l.497 1.324c.04.106.14.176.253.176s.213-.07.253-.176L10.5 3l1.324-.497a.271.271 0 0 0 0-.506L10.5 1.5 10.003.176a.271.271 0 0 0-.506 0L9 1.5zm-2.869-.279a.374.374 0 0 0-.68 0L2.89 4.39.218 5.625a.374.374 0 0 0 0 .682l2.674 1.235 1.233 2.672a.373.373 0 0 0 .68 0L6.04 7.54l2.674-1.235a.374.374 0 0 0 0-.68L6.042 4.392zM9 9l-1.324.497a.271.271 0 0 0 0 .506L9 10.5l.497 1.324c.04.106.14.176.253.176s.213-.07.253-.176L10.5 10.5l1.324-.497a.271.271 0 0 0 0-.506L10.5 9l-.497-1.324a.271.271 0 0 0-.506 0z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h12v12H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }